/** When false, the virtual assistant does not navigate or suggest page redirects. */
export const ASSISTANT_NAVIGATION_ENABLED = false;

export function isAssistantNavigationCommandId(id: string): boolean {
  return id.startsWith('nav_');
}
